import { render, staticRenderFns } from "./compete.vue?vue&type=template&id=8d9154e6&"
import script from "./compete.vue?vue&type=script&lang=js&"
export * from "./compete.vue?vue&type=script&lang=js&"
import style0 from "./compete.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports